<template>
  <nav-bar title="添加存量客户" />
  <Content :bottom="0">
    <van-notice-bar
      wrapable
      :scrollable="false"
      text="新建客户时会自动生成以客户手机号为用户名的账号，初始密码aq#123456"
    />
    <van-form @submit="handleSubmit">
      <Picker
        label="客户类型"
        :require="true"
        :columns="columns"
        :defaultVal="userTypeName"
        @confirm-values="value => (userType = value.dicVal)"
      />
      <van-field
        name="code"
        v-model="creditNo"
        label="客户代码："
        type="text"
        v-if="userType !== '04' && userType !== '05'"
        placeholder="企业统一社会信用代码或个体户注册号等"
        :rules="[{ required: true, message: '此项为必填项' },{ validator: asyncValidator, message: creditNoMessage }]"
      />
      <van-field
        name="name"
        v-model="companyName"
        label="客户名："
        placeholder="请输入客户姓名或单位名称"
        :rules="[{ required: true, message: '此项为必填项' }]"
      />
      <van-field
        name="name"
        v-model="userName"
        label="联系人"
        placeholder="联系人"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        name="tel"
        v-model="phoneNum"
        label="联系电话"
        placeholder="联系电话"
        :rules="[{ required: true, message: '请填写电话' }]"
      />
      <Picker
        label="街道"
        pickerType="cascader"
        :defaultVal="streetName"
        @confirm-values="value => (streetCode = value)"
      />
      <van-field
        type="textarea"
        name="address"
        v-model="address"
        label="地址："
        placeholder="请输入"
        :rules="[{ required: true, message: '此项为必填项' }]"
      />
      <Picker
        label="合同开始时间"
        pickerType="time"
        :defaultVal="contractSdate"
        @confirm-values="val => contractSdate = val"
      />
      <Picker
        label="合同结束时间"
        pickerType="time"
        :maxDate="afterYear(5)"
        :defaultVal="contractEdate"
        @confirm-values="val => contractEdate = val"
      />
      <van-field
        name="name"
        v-model="handlerName"
        label="经办人"
        placeholder="经办人"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        name="tel"
        v-model="handlerTel"
        label="经办人电话"
        placeholder="经办人电话"
        :rules="[{ required: true, message: '请填写电话' }]"
      />
      <van-field name="uploader" label="合同及现场" >
        <template #input>
          <van-uploader  v-model="fileList" :after-read="afterRead"  />
        </template>
      </van-field>
      <SelectPoint @get-value="selectPoint" :defaultValue="(longitude || 0) +','+ (latitude || 0)" />
      <div class="btn-container">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="submit"
        >
          确认添加
        </van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { Toast, Notify } from 'vant'
import { reactive, toRefs, computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { useGetData } from '@/hooks/useGetData'
import { addCustomer, getMessListById, queryCustomerMessForCom } from '@/api/customer'
import SelectPoint from './SelectPoint.vue'
import getImgFile from '@/utils/getImgFile'
import { afterYear } from '@/utils/common'
export default {
  name: 'AddCustomer', // 添加客户
  components: { SelectPoint },
  setup(props) {
    const store = useStore()
    const route = useRoute()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const departId = computed(() => store.state.roleInfo.departId)
    const status = ref('1')
    // 文件上传
    const fileList = ref([])
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList)
    }
    const params = {
      userStatus: '01',
      departId: route.query.type === 'company' ? '' : departId.value,
      companyId: companyId.value
    }
    const formData = reactive({
      userName: '',
      phoneNum: '',
      address: '',
      companyName: '',
      userType: '',
      creditNo: '',
      streetCode: '',
      longitude: 0.0,
      latitude: 0.0,
      imgList: imgPath,
      contractSdate: '',
      contractEdate: '',
      streetName: '',
      userTypeName: '',
      handlerName: '',
      handlerTel: '',
      ...params
    })
    const router = useRouter()
    const handleSubmit = () => {
      const { onSubmit } = useSubmit(status.value === '1' || status.value === '3' ? addCustomer : noticeAlarm, formData, () => {
        router.back()
      })
      onSubmit()
    }
    const noticeAlarm = () => {
      Notify({ type: 'warning', message: '客户已经存在于本公司，无法添加！' })
    }
    // 选择位置
    const point = ref('') // 位置
    const selectPoint = value => {
      point.value = value
      formData.longitude = value[1]
      formData.latitude = value[0]
    }

    // LIST
    const columns = ref([])
    useGetData(getMessListById, data => {
      columns.value = data
    })()

    const isError = ref(false)
    const creditNoMessage = () => isError.value ? '验证出现错误' : '该客户代码已被占用'
    const isOk = ref(false)
    const isOkValue = ref('')
    const asyncValidator = (val) => {
      if (isOk.value && isOkValue.value === val) { return }
      const res = new Promise((resolve) => {
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: '验证中...'
        })
        queryCustomerMessForCom({
          creditNo: val,
          companyId: companyId.value
        }).then(res => {
          res = res.data
          isError.value = false
          if (res.cuMess) {
            for (const key in res.cuMess) {
              if (key !== 'imgList' && key !== 'userStatus' && key !== 'companyId' && key !== 'departId') {
                formData[key] = res.cuMess[key]
              }
            }
            fileList.value = res.cuMess.imgList ? res.cuMess.imgList.map(item => ({ url: item, status: 'done' })) : []
          }
          status.value = res.status
          isOk.value = true
          isOkValue.value = val
          resolve(res.status !== '2')
          Toast.clear()
        }).catch(() => {
          isError.value = true
          resolve(false)
          Toast.clear()
        })
      })
      return res
    }
    return {
      ...toRefs(formData),
      loading,
      departId,
      companyId,
      selectPoint,
      columns,
      fileList,
      afterRead,

      imgPath,
      afterYear,
      asyncValidator,
      creditNoMessage,
      status,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
